<template>
  <div>
    <b-card-header
      style="margin-top: -25px;"
    >
      <Card-Menu-Top />
      <Card-Map />
      <Card-Lighting />
      <Card-Counting-Bar />
      <Card-Counting-Formula />
      <Card-Counting-Graph />
      <br>
      <Card-CCTV />
      <br>
      <Card-VMS />
      <br>
      <Card-Traffic />
    </b-card-header></div>
</template>

<script>
import {
  BCardHeader,
} from 'bootstrap-vue'
import CardMenuTop from '@/views/dashboard/CardMenuTopDB.vue'
import CardMap from '@/views/dashboard/CardMapDB.vue'
import CardCountingBar from '@/views/dashboard/CardCountingBarDB.vue'
import CardCountingFormula from '@/views/dashboard/CardCountingFormulaDB.vue'
import CardCountingGraph from '@/views/dashboard/CardCountingGraphDB.vue'
import CardCCTV from '@/views/dashboard/CardCCTVDB.vue'
import CardVMS from '@/views/dashboard/CardVMSDB.vue'
import CardTraffic from '@/views/dashboard/CardTrafficDB.vue'
import CardLighting from '@/views/dashboard/LightingStatistics.vue'

export default {
  components: {
    CardMenuTop,
    CardMap,
    CardCountingBar,
    CardCountingFormula,
    CardCountingGraph,
    CardCCTV,
    CardVMS,
    CardTraffic,
    BCardHeader,
    CardLighting,
    // BImg,
    // BLink,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  created() {
  },
  mounted() {
  },
  // methods: {
  //   getWayCount() {
  //     axios
  //       .post('/getWayCountDetail', { wid: this.$route.query.wid })
  //       .then(response => {
  //         this.center = []
  //         this.center.push(response.data[0].latitude - 0.00135)
  //         this.center.push(response.data[0].longitude)
  //         this.waydetail = response.data[0].detail
  //         this.markers = response.data
  //       })
  //       .catch(error => {
  //         console.log(error)
  //       })
  //   },
  //   stream(value, camdesc) {
  //     // eslint-disable-next-line no-return-assign
  //     setTimeout(() => {
  //       this.camdesc = camdesc
  //       const hls = new Hls({
  //         lowLatencyMode: true,
  //         autoreconnect: true,
  //       })
  //       const stream = value
  //       const video = document.querySelector('#video')
  //       hls.loadSource(stream)
  //       hls.attachMedia(video)
  //       hls.on(Hls.Events.MANIFEST_PARSED, () => {
  //         video.play()
  //       })
  //       hls.on(Hls.Events.ERROR, () => {
  //         video.play()
  //       })
  //     }, 500)
  //   },
  // },
}
</script>

<style lang="scss" scoped>
  @import '@core/scss/vue/libs/vue-flatpicker.scss';

.text1 {
  position: absolute;
  font-family: Arial;
  top: 20px;
  right: 20px;
  color: white;
}
.text2 {
  position: absolute;
  font-family: Arial;
  top: 20px;
  right: 20px;
  color: white;
}
</style>
